import { Starfield } from '../../components/Starfield/Starfield';
import { usePointerParallax } from '../../hooks/usePointerParallax';
import './ComingSoon.scss';

const TITLE = 'Coming Soon';

/**
 * A circle of radius 38 inside the `0 0 100 100` viewBox, drawn as two arcs
 * running clockwise from the leftmost point. Keeping the geometry in viewBox
 * units means the arc scales with the SVG box and needs no per-breakpoint
 * maths.
 *
 * Distance along that path maps to: 0% left, 25% top, 50% right, 75% bottom.
 */
const ARC_PATH = 'M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0';

/** 25% is top dead centre; `text-anchor: middle` centres the words on it. */
const TITLE_OFFSET = '25%';

export const ComingSoon = () => {
  // Publishes `--pointer-x` / `--pointer-y`; each layer below picks its own
  // depth off them, so the scene parallaxes as the cursor moves.
  const sceneRef = usePointerParallax<HTMLElement>();

  return (
    <main className="coming-soon" ref={sceneRef}>
      <div className="coming-soon__nebula" aria-hidden="true" />
      <Starfield />
      {/*
        The corona is a sibling rather than a pseudo-element of the orb: negative
        z-index children still paint above their parent's own background, so a
        `::before` glow would sit on top of the disc instead of behind it.
      */}
      <div className="coming-soon__glow" aria-hidden="true" />
      <div className="coming-soon__orb" aria-hidden="true" />

      <h1 className="coming-soon__title">
        <span className="coming-soon__sr-only">{TITLE}</span>
        <svg
          className="coming-soon__arc"
          viewBox="0 0 100 100"
          aria-hidden="true"
          focusable="false"
        >
          <defs>
            <path id="coming-soon-arc-path" d={ARC_PATH} />
          </defs>
          <text textAnchor="middle">
            <textPath href="#coming-soon-arc-path" startOffset={TITLE_OFFSET}>
              {'COMING SOON'}
            </textPath>
          </text>
        </svg>
      </h1>

      <div className="coming-soon__footer">
        <p className="coming-soon__status">
          <span className="coming-soon__dot" aria-hidden="true" />
          Something new is taking shape
        </p>
      </div>

      <div className="coming-soon__grain" aria-hidden="true" />
      <div className="coming-soon__vignette" aria-hidden="true" />
    </main>
  );
};
